





























import { defineComponent } from '@vue/composition-api';
import { DropdownFilter, IFieldFilter } from '@/models/filters/Filters';
import PaginatedAutocomplete from '@/components/utils/PaginatedAutocomplete.vue';

interface Props {
  initialValue?: number[];
  onChange?: Function;
  filter: IFieldFilter;
  rules?: Array<(a: any) => boolean | string>;
}

const Component = defineComponent({
  name: 'ColorsPaginatedAutocomplete',

  props: {
    initialValue: Array,
    onChange: Function,
    filter: Object,
    rules: Array,
  },
  components: { PaginatedAutocomplete },

  setup() {
    return {
      DropdownFilter,
    };
  },
});

export default Component;
